import React, { Component } from 'react'
import cls from 'classnames'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'
import { MagicInput } from 'hljd'

import { CloseCircleOutlined } from '@ant-design/icons'

import Styles from '../index.module.less'

@inject('uniqueInfoStore')
@observer
export default class extends Component {
  render() {
    const {
      tags,
      changeTags,
      prohibitCheck,
      prohibit
    } = this.props.uniqueInfoStore
    const { index } = this.props
    const value = toJS(tags)[index] || ''
    return (
      <div className={Styles.item}>
        <h4>特色{index === 0 ? '一' : '二'}</h4>
        <div className={Styles.content}>
          <div>建议填写鲜明的特色，让客人一眼就记住你的酒店</div>
          <div>eg: 刘诗诗婚礼举办地 、杭州唯美湖景露台、阿里巴巴年会场地</div>
          <div
            className={cls(Styles.input, {
              [Styles.input_wrap]: prohibit[index]
            })}
          >
            <MagicInput
              onBlur={e => prohibitCheck(index)(e.target.value)}
              style={{ width: 440 }}
              value={value}
              size="large"
              onChange={e => changeTags(index)(e.target.value)}
              maxLength={12}
              countPosition="right"
              showCount
            />
          </div>
          {prohibit[index] && (
            <div className={Styles.prohibit_word_tips}>
              <CloseCircleOutlined className={Styles.close_icon} />
              您输入的内容中包含违禁词：{prohibit[index]}
            </div>
          )}
        </div>
      </div>
    )
  }
}
